// @ts-nocheck
'use client';

// Get user's servers
export async function apiGetMyServers() {
  const res = await fetch('/api/hosting/servers', { method: 'GET' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to fetch servers');
  return data;
}

// Get a specific server by name
export async function apiGetServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}`, { method: 'GET', cache: 'no-store' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to fetch server');
  return data;
}

// Get historical resource usage points for graph ranges
export async function apiGetResourceHistory(serverName, range = '15m') {
  const res = await fetch(
    `/api/hosting/servers/${encodeURIComponent(serverName)}/resources/history?range=${encodeURIComponent(range)}`,
    { method: 'GET', cache: 'no-store' }
  );
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to fetch resource history');
  return data;
}

// Check if server name is available
export async function apiCheckServerName(name) {
  const res = await fetch(`/api/hosting/check-name?name=${encodeURIComponent(name)}`, { method: 'GET' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to check name');
  return data;
}

// Rename a server
export async function apiRenameServer(serverName, newName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/rename`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ newName }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to rename server');
  return data;
}

// Create a new server
export async function apiCreateServer(payload) {
  const res = await fetch('/api/hosting/servers', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to create server');
  return data;
}

// Get server console logs
export async function apiGetConsoleLogs(serverName, limit = 500) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/console?limit=${limit}`, { method: 'GET', cache: 'no-store' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to fetch console logs');
  return data;
}

// Send command to server console
export async function apiSendCommand(serverName, command) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/console`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ command }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to send command');
  return data;
}

// Start server
export async function apiStartServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/power`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'start' }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to start server');
  return data;
}

// Stop server
export async function apiStopServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/power`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'stop' }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to stop server');
  return data;
}

// Force-stop (kill) server
export async function apiKillServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/power`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'kill' }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to force-stop server');
  return data;
}

// Restart server
export async function apiRestartServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/power`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'restart' }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to restart server');
  return data;
}

// Get schedules for a server
export async function apiGetServerSchedules(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/schedules`, {
    method: 'GET',
    cache: 'no-store',
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to fetch schedules');
  return data;
}

// Create a server schedule
export async function apiCreateServerSchedule(serverName, payload) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/schedules`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to create schedule');
  return data;
}

// Update an existing schedule
export async function apiUpdateServerSchedule(serverName, id, payload) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/schedules`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, ...payload }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to update schedule');
  return data;
}

// Enable or disable an existing schedule
export async function apiSetServerScheduleEnabled(serverName, id, enabled) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/schedules`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, enabled }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to update schedule');
  return data;
}

// Delete a server schedule
export async function apiDeleteServerSchedule(serverName, id) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/schedules`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to delete schedule');
  return data;
}

// Delete server
export async function apiDeleteServer(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/delete`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    // The API refuses to delete unless the exact server name is restated
    body: JSON.stringify({ confirmName: serverName }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to delete server');
  return data;
}

// Update server icon
export async function apiUpdateServerIcon(serverName, iconUsername) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/settings`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ icon_username: iconUsername }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to update server icon');
  return data;
}

// Create Stripe checkout session
export async function apiCreateStripeCheckout(serverData) {
  const res = await fetch('/api/hosting/payments/stripe/create-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(serverData),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to create checkout session');
  return data;
}

// Create PayPal subscription
export async function apiCreatePayPalSubscription(serverData) {
  const res = await fetch('/api/hosting/payments/paypal/create-subscription', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(serverData),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to create PayPal subscription');
  return data;
}

// ============================================
// File Manager API
// ============================================

function normalizeFileServerUrl(value) {
  if (!value) return null;
  try {
    return new URL(String(value).replace(/\/+$/, '')).toString().replace(/\/+$/, '');
  } catch (_) {
    return null;
  }
}

function resolveFileTransport(serverName, options = {}) {
  const connectionMethod = options.connectionMethod === 'direct' ? 'direct' : 'proxy';
  if (connectionMethod === 'direct') {
    const fileServerUrl = normalizeFileServerUrl(options.connection?.fileServerUrl);
    const apiKey = options.connection?.apiKey;
    if (!fileServerUrl || !apiKey) {
      throw new Error('Direct file connection is unavailable');
    }
    return { connectionMethod, fileServerUrl, apiKey };
  }

  return { connectionMethod, fileServerUrl: null, apiKey: null };
}

async function requestFileJson(serverName, endpoint, options = {}) {
  const transport = resolveFileTransport(serverName, options);
  if (transport.connectionMethod === 'direct') {
    const url = new URL(endpoint, transport.fileServerUrl);
    url.searchParams.set('server', serverName);
    const init: any = {
      method: options.method || 'GET',
      headers: { 'x-api-key': transport.apiKey },
    };

    if (options.body !== undefined) {
      init.headers = { ...(init.headers || {}), 'Content-Type': 'application/json' };
      init.body = JSON.stringify(options.body);
    }

    const res = await fetch(url.toString(), init);
    const data = await res.json().catch(() => null);
    if (!res.ok) throw new Error(data?.error || 'File server request failed');
    return data;
  }

  const url = new URL(`/api/hosting/servers/${encodeURIComponent(serverName)}/files`, window.location.origin);
  const fetchInit: any = {
    method: options.method || 'GET',
    headers: options.headers || undefined,
  };
  if (options.body !== undefined) {
    fetchInit.headers = { ...(fetchInit.headers || {}), 'Content-Type': 'application/json' };
    fetchInit.body = JSON.stringify(options.body);
  }

  const res = await fetch(url.toString(), fetchInit);
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to perform file operation');
  return data;
}

export async function apiDownloadFile(serverName, filePath, options = {}) {
  const transport = resolveFileTransport(serverName, options);

  if (transport.connectionMethod === 'direct') {
    const url = new URL('/files/download', transport.fileServerUrl);
    url.searchParams.set('server', serverName);
    url.searchParams.set('path', filePath);
    return fetch(url.toString(), {
      headers: { 'x-api-key': transport.apiKey },
    });
  }

  const url = new URL(`/api/hosting/servers/${encodeURIComponent(serverName)}/files`, window.location.origin);
  url.searchParams.set('action', 'download');
  url.searchParams.set('path', filePath);
  return fetch(url.toString());
}

// List files in a directory
export async function apiListFiles(serverName, dirPath = '/server', options = {}) {
  return requestFileJson(serverName, `/files/list?action=list&path=${encodeURIComponent(dirPath)}`, {
    ...options,
    method: 'GET',
  });
}

// Read a text file
export async function apiReadFile(serverName, filePath, options = {}) {
  return requestFileJson(serverName, `/files/read?action=read&path=${encodeURIComponent(filePath)}`, {
    ...options,
    method: 'GET',
  });
}

// Get recursive size for a file/directory in bytes
export async function apiGetPathSize(serverName, filePath, options = {}) {
  const data = await requestFileJson(serverName, `/files/size?action=size&path=${encodeURIComponent(filePath)}`, {
    ...options,
    method: 'GET',
  });
  return {
    ...data,
    sizeBytes: Number(data?.sizeBytes || 0),
  };
}

// Get storage usage/limit for a server (in MB/GB)
export async function apiGetStorage(serverName, options = {}) {
  return requestFileJson(serverName, '/files/storage', {
    ...options,
    method: 'GET',
  });
}

// Write a text file
export async function apiWriteFile(serverName, filePath, content, options = {}) {
  return requestFileJson(serverName, '/files/write', {
    ...options,
    method: 'POST',
    body: { action: 'write', path: filePath, content },
  });
}

// Create a new file
export async function apiCreateFile(serverName, filePath, options = {}) {
  return requestFileJson(serverName, '/files/create', {
    ...options,
    method: 'POST',
    body: { action: 'create', path: filePath },
  });
}

// Create a new directory
export async function apiCreateDir(serverName, dirPath, options = {}) {
  return requestFileJson(serverName, '/files/mkdir', {
    ...options,
    method: 'POST',
    body: { action: 'mkdir', path: dirPath },
  });
}

// Delete a file or directory. `allowProtected` asks the file server to permit a protected
// path (server.jar, Apect plugin/mod jars); the panel only sets it for admins, and the
// proxied route re-checks that server-side.
export async function apiDeleteFile(serverName, filePath, options: any = {}) {
  const { allowProtected, ...rest } = options || {};
  return requestFileJson(serverName, '/files/delete', {
    ...rest,
    method: 'POST',
    body: { action: 'delete', path: filePath, ...(allowProtected ? { allowProtected: true } : {}) },
  });
}

// Rename a file or directory
export async function apiRenameFile(serverName, filePath, newName, options: any = {}) {
  const { allowProtected, ...rest } = options || {};
  return requestFileJson(serverName, '/files/rename', {
    ...rest,
    method: 'POST',
    body: { action: 'rename', path: filePath, newName, ...(allowProtected ? { allowProtected: true } : {}) },
  });
}

// Move a file or directory
export async function apiMoveFile(serverName, sourcePath, destPath, options: any = {}) {
  const { allowProtected, ...rest } = options || {};
  return requestFileJson(serverName, '/files/move', {
    ...rest,
    method: 'POST',
    body: { action: 'move', sourcePath, destPath, ...(allowProtected ? { allowProtected: true } : {}) },
  });
}

// Upload a file as raw binary so large uploads do not pay base64 overhead.
export function apiUploadFile(serverName, filePath, file, onProgress, options = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const transport = resolveFileTransport(serverName, options);
    const url = transport.connectionMethod === 'direct'
      ? new URL('/files/upload', transport.fileServerUrl).toString() + `?server=${encodeURIComponent(serverName)}&path=${encodeURIComponent(filePath)}`
      : `/api/hosting/servers/${encodeURIComponent(serverName)}/files?path=${encodeURIComponent(filePath)}`;

    xhr.open('POST', url, true);
    xhr.responseType = 'text';
    // Note: path is passed via the URL query string above, not a custom
    // header — the file server's CORS Access-Control-Allow-Headers list
    // doesn't include X-Upload-Path, and sending it here would fail the
    // CORS preflight for direct-mode (cross-origin) uploads.
    xhr.setRequestHeader('Content-Type', file?.type || 'application/octet-stream');
    if (transport.connectionMethod === 'direct') {
      xhr.setRequestHeader('x-api-key', transport.apiKey);
    }

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && typeof onProgress === 'function') {
        onProgress({ loaded: event.loaded, total: event.total });
      }
    };

    xhr.onload = () => {
      const text = xhr.responseText || '';
      let data = null;
      try { data = text ? JSON.parse(text) : null; } catch (e) { /* non-JSON response */ }
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new Error(data?.error || `Upload failed (HTTP ${xhr.status}): ${text.slice(0, 200)}`));
        return;
      }
      resolve(data);
    };

    xhr.onerror = () => {
      reject(new Error('Network error: Failed to reach server'));
    };

    xhr.onabort = () => {
      reject(new Error('Upload aborted'));
    };

    xhr.send(file);
  });
}

// Archive files/folders
export async function apiArchiveFiles(serverName, basePath, items, archiveName, options = {}) {
  return requestFileJson(serverName, '/files/archive', {
    ...options,
    method: 'POST',
    body: { action: 'archive', basePath, items, archiveName },
  });
}

// Extract an archive file
export async function apiExtractFile(serverName, filePath, destDir, options = {}) {
  return requestFileJson(serverName, '/files/extract', {
    ...options,
    method: 'POST',
    body: { action: 'extract', filePath, destDir },
  });
}

// Get visibility settings
export async function apiGetVisibility(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/visibility`, { method: 'GET' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to get visibility settings');
  return data;
}

// Save visibility settings
export async function apiSaveVisibility(serverName, payload) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/visibility`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to save visibility settings');
  return data;
}

// Get whitelist (enabled flag + list) - the list always comes from whitelist.json on the server
export async function apiGetWhitelist(serverName) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/whitelist`, { method: 'GET' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to get whitelist');
  return data as { enabled: boolean; whitelist: string[]; online: boolean };
}

// Save whitelist (enabled flag + list): applied with whitelist commands when the
// server is online, written to the server files when it is offline
export async function apiSaveWhitelist(serverName, payload: { enabled?: boolean; whitelist?: string[] }) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/whitelist`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to save whitelist');
  return data;
}

// Get download URL for a file
export function getFileDownloadUrl(serverName, filePath, options = {}) {
  const transport = resolveFileTransport(serverName, options);
  if (transport.connectionMethod === 'direct') {
    const url = new URL('/files/download', transport.fileServerUrl);
    url.searchParams.set('server', serverName);
    url.searchParams.set('path', filePath);
    return url.toString();
  }
  return `/api/hosting/servers/${encodeURIComponent(serverName)}/files?action=download&path=${encodeURIComponent(filePath)}`;
}

// ============================================
// Plugin Installer API
// ============================================

// Search plugins from all sources (combined)
export async function apiSearchPlugins(query, page = 1, limit = 30, type = 'plugin', loader?: string) {
  const params = new URLSearchParams({ q: query, page: String(page), limit: String(limit), type });
  // Mods are loader-specific, so a mod search says which loader it is for.
  if (loader) params.set('loader', loader);
  const res = await fetch(`/api/hosting/plugins/search?${params}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to search plugins');
  return data;;
}

// Get plugin details and versions
export async function apiGetPluginDetails(pluginId, source = 'modrinth') {
  const res = await fetch(`/api/hosting/plugins/${encodeURIComponent(pluginId)}?source=${source}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to get plugin details');
  return data;
}

// Install a plugin to a server
export async function apiInstallPlugin(serverName, payload) {
  const res = await fetch(`/api/hosting/servers/${encodeURIComponent(serverName)}/plugins/install`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to install plugin');
  return data;
}

// Calculate price based on plan configuration
export function calculatePrice(plan, ramGb, storageGb, cpuCores, planConfig, pricingConfig) {
  if (plan === 'free') return 0;
  
  const planData = planConfig[plan];
  if (!planData || !planData.configurable) return 0;
  
  // RAM cost
  const ramCost = ramGb * planData.price_per_gb_ram;
  
  // Storage cost (first 25GB free, then $1/25GB)
  const freeStorage = pricingConfig.free_storage_gb || 25;
  const extraStorage = Math.max(0, storageGb - freeStorage);
  const storageCost = (extraStorage / 25) * (pricingConfig.price_per_25gb_storage || 1);
  
  // CPU cost (first 4 cores free, then $2.5/core)
  const freeCores = pricingConfig.free_cpu_cores || 4;
  const extraCores = Math.max(0, cpuCores - freeCores);
  const cpuCost = extraCores * (pricingConfig.price_per_extra_core || 2.5);
  
  return Math.round((ramCost + storageCost + cpuCost) * 100) / 100;
}